export enum OrderType {
  Manual,
  Customer,
  POS,
}

export const OrderTypeMap: { [key: number]: string } = {
  [OrderType.Manual]: 'Manual',
  [OrderType.Customer]: 'Customer',
  [OrderType.POS]: 'POS',
};
